import { AnalyticsPlugin, IPulsePluginContext, PulseBatch, PulseEventMessage } from '@pulse/common';

export class PluginHost implements AnalyticsPlugin {
    private plugins: AnalyticsPlugin[] = [];

    init(context: IPulsePluginContext) {
        this.plugins.forEach((p) => p.init && p.init(context));
    }

    enqueue(message: PulseEventMessage, context: IPulsePluginContext): boolean {
        return this.plugins.every((plugin) =>
            plugin.enqueue ? plugin.enqueue(message, context) : true,
        );
    }

    beforeBatchSend(batch: PulseBatch, context: IPulsePluginContext): PulseBatch | null {
        return this.plugins.reduce<PulseBatch | null>((batch, plugin) => {
            if (batch && plugin.beforeBatchSend) {
                return plugin.beforeBatchSend(batch, context);
            }

            return batch;
        }, batch);
    }

    batchSent(batch: PulseBatch, context: IPulsePluginContext): void {
        this.plugins.forEach((p) => p.batchSent && p.batchSent(batch, context));
    }

    sessionChange() {
        throw new Error('Method not implemented.');
    }

    stateChange() {
        throw new Error('Method not implemented.');
    }

    register(plugin: AnalyticsPlugin) {
        this.plugins.push(plugin);
    }
}
